import { render, staticRenderFns } from "./ProposalDetails.view.vue?vue&type=template&id=6b5c736e&"
import script from "./ProposalDetails.view.vue?vue&type=script&lang=js&"
export * from "./ProposalDetails.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5c736e')) {
      api.createRecord('6b5c736e', component.options)
    } else {
      api.reload('6b5c736e', component.options)
    }
    module.hot.accept("./ProposalDetails.view.vue?vue&type=template&id=6b5c736e&", function () {
      api.rerender('6b5c736e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/update/protocol/ProposalDetails.view.vue"
export default component.exports